<script setup>
    import axios from 'axios';
    import { ref } from 'vue';
    import passwordMeter from 'vue-simple-password-meter';

    const props = defineProps(['updateUrl', 'userID', 'userName', 'isVerified', 'isOpen', 'returnLink']);
    const hasErrors = ref(false);
    const success = ref(false);

    const submitData = ref({
        username: props.userName,
        old_password: '',
        new_password: '',
        new_password_retype: '',
    });

    const errors = ref(null);

    async function submit() {
        hasErrors.value = false;
        errors.value = {};

        axios.post(props.updateUrl, submitData.value).then( response => {
            if (response.status === 200) {
                // redirect after 5 seconds.
                success.value = true;
                setTimeout(function() {window.location.replace(props.returnLink)}, 5000);
            }
        }).catch( error => {
            if(error.response.status === 422) {
                hasErrors.value = true;
                errors.value = error.response.data || {
                    general: error.response.data.message
                };
            } else {
                hasErrors.value = true;
                errors.value = {
                    general: error.response.data.message
                };
            }
        });
    }

</script>
<template>

    <div id="securityform">
        <div class="well">
            <form @submit.prevent="submit" method="post">

                <div class="form-group row" v-if="isVerified">
                    <label class="col-sm-3 col-form-label">Benutzername:</label>
                    <div class="col-sm-9">
                        <input
                            name="username"
                            type="text"
                            v-model="submitData.username"
                            :class="{
                                'form-control': true,
                                'is-valid' : (success && typeof errors.changeUsername === 'undefined'),
                                'is-invalid' : (hasErrors && typeof errors.changeUsername !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(hasErrors && typeof errors.username !== 'undefined')">
                            {{ errors.username[0] }}
                        </div>
                    </div>
                </div>

                <div class="form-group row" v-if="isVerified">
                    <label class="col-sm-3 col-form-label">Altes Passwort:</label>
                    <div class="col-sm-9">
                        <input
                            name="old_password"
                            type="password"
                            v-model="submitData.old_password"
                            :class="{
                                'form-control': true,
                                'is-valid': (success && typeof errors.old_password === 'undefined'),
                                'is-invalid': (hasErrors && typeof errors.old_password !== 'undefined'),
                            }"
                        />
                        <div class="invalid-feedback" v-if="(hasErrors && typeof errors.old_password !== 'undefined')">
                            {{ errors.old_password[0] }}
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Neues Passwort:</label>
                    <div class="col-sm-9">
                        <input
                            name="new_password"
                            type="password"
                            v-model="submitData.new_password"
                            :class="{
                                'form-control': true,
                                'is-valid': (success && typeof errors.new_password === 'undefined'),
                                'is-invalid': (hasErrors && typeof errors.new_password !== 'undefined'),
                            }"
                        />
                        <password-meter :password="submitData.new_password" />
                        <!-- include a password strength meter here -->
                        <div class="invalid-feedback" v-if="(hasErrors && typeof errors.new_password !== 'undefined')">
                            {{ errors.new_password[0] }}
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Neues wiederholen:</label>
                    <div class="col-sm-9">
                        <input
                            name="new_password_retype"
                            type="password"
                            v-model="submitData.new_password_retype"
                            :class="{
                                'form-control': true,
                                'is-valid': (success && typeof errors.new_password_retype === 'undefined'),
                                'is-invalid': (hasErrors && typeof errors.new_password_retype !== 'undefined'),
                            }"
                        />
                        <!-- include a password strength meter here -->
                        <div class="invalid-feedback" v-if="(hasErrors && typeof errors.new_password_retype !== 'undefined')">
                            {{ errors.new_password_retype[0] }}
                        </div>
                    </div>
                </div>
                <p><small>(Ihr Passwort muss mindestens 10 Zeichen lang sein und mindestens einen Großbuchstaben, eine Zahl und ein Sonderzeichen beinhalten)</small></p>

            </form>

            <div class="alert alert-danger" role="alert" v-if="(hasErrors && typeof errors.general !== 'undefined')">
                {{ errors.general[0] }}
            </div>

            <div class="table-footer">
                <button class="btn btn-link footer-button" type="submit" @click.prevent="submit">
                    Speichern<i class="far fa-lg fa-save"></i>
                </button>
                <a class="btn btn-link footer-button" type="submit" :href="props.returnLink">
                    Abbrechen<i class="fas fa-lg fa-times"></i>
                </a>
            </div>

            <div class="alert alert-success" role="alert" v-if="success">
                Neues Passwort erfolgreich gespeichert! Sie werden gleich weitergeleitet.
            </div>

        </div>
    </div>

</template>
